import {
  UPDATE_EMAIL_SUCCESS,
  UPDATE_PASSWORD_SUCCESS,
} from "redux/auth/auth.types";

import {
  SAVE_TOKEN,
  GET_ME,
  GET_ME_SUCCESS,
  REMOVE_TOKEN,
  HIDE_LOADING
} from "./profile.types";

const initialState = {
  accessToken: "",
  email: "",
  userId: "",
  loading: true,
};

export const profileReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SAVE_TOKEN:
      return { ...state, accessToken: payload };
    case REMOVE_TOKEN:
      return { ...state, accessToken: null };

    case GET_ME:
      return { ...state, loading: true };
    case GET_ME_SUCCESS:
      return {
        ...state,
        loading: false,
        email: payload.email,
        userId: payload._id,
      };

    case HIDE_LOADING:
      return { ...state, loading: false };

    case UPDATE_EMAIL_SUCCESS:
      return { ...state, email: payload.email, loading: false };

    case UPDATE_PASSWORD_SUCCESS:
      return { ...state, state, loading: false };

    default:
      return state;
  }
};
